export default __webpack_public_path__ + "static/whats_icon-3d1aa548b551c8b822357c3292f790db.png";